const metadataInitialContent = {
  robotsIndex: "yes",
};

const metadataPropertiesGroup = {
  title: "Metadata",
  properties: ["metaDataDescription", "metaDataKeywords", "robotsIndex"],
};

const socialCardsPropertiesGroup = {
  title: "Open Graph",
  component: "SocialCardsTab",
};

export {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
};
